import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=ba8f5dfe&scoped=true&"
import script from "./AccountProfile.vue?vue&type=script&lang=js&"
export * from "./AccountProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfile.vue?vue&type=style&index=0&id=ba8f5dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f5dfe",
  null
  
)

export default component.exports